import { usePreferencesStore } from '~/stores/preferencesStore'
import { useLogger } from './useLogger'
import { usePostHog, ONBOARDING_EVENTS } from '~/composables/usePostHog'
import { useFirebaseAnalytics } from '~/composables/useFirebaseAnalytics'

// Keep track of whether we've checked first launch
let hasCheckedFirstLaunch = false

export const useFirstLaunchOnDevice = () => {
  const logger = useLogger()
  const preferencesStore = usePreferencesStore()
  const posthog = usePostHog()
  const analytics = useFirebaseAnalytics()

  const checkFirstLaunch = async (source: 'clock' | 'login' | 'signup') => {
    if (!process.client || hasCheckedFirstLaunch) {
      return false
    }

    try {
      hasCheckedFirstLaunch = true
      const isFirstLaunchOnDevice = await preferencesStore.isFirstLaunchOnDevice()

      if (isFirstLaunchOnDevice) {
        logger.debug('First time app launch on this device detected', { source })

        // Track first time launch in analytics
        await posthog.capture(ONBOARDING_EVENTS.FIRST_TIME_DEVICE_LAUNCH, {
          source,
          timestamp: new Date().toISOString()
        })
        await analytics.logEvent(ONBOARDING_EVENTS.FIRST_TIME_DEVICE_LAUNCH, {
          source,
          timestamp: new Date().toISOString()
        })

        // Set the flag to prevent future checks
        await preferencesStore.markAsLaunchedOnDevice()
        return true
      }

      return false
    } catch (error) {
      logger.logErrorCaught('Error checking first launch on device', 'useFirstLaunchOnDevice.ts', error)
      return false
    }
  }

  return {
    checkFirstLaunch
  }
} 